module.exports = require("jsdom");


//////////////////
// WEBPACK FOOTER
// external "jsdom"
// module id = 41
// module chunks = 0